import { render, staticRenderFns } from "./todayCollect.vue?vue&type=template&id=5384029f&scoped=true&"
import script from "./todayCollect.vue?vue&type=script&lang=js&"
export * from "./todayCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5384029f",
  null
  
)

export default component.exports